import { render, staticRenderFns } from "./PatientEstimate.vue?vue&type=template&id=6c994698&"
import script from "./PatientEstimate.vue?vue&type=script&lang=ts&"
export * from "./PatientEstimate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports